import { Directive, ViewContainerRef, ContentChildren } from '@angular/core';
import { ComplexBase, ArrayBase, setValue } from '@syncfusion/ej2-angular-base';



let /** @type {?} */ input: string[] = ['end', 'label', 'start'];
let /** @type {?} */ outputs: string[] = [];
/**
 * 'e-presets' directive represent a presets of angular daterangepicker 
 * It must be contained in a daterangepicker component(`ej-daterangepicker`). 
 * ```html
 * <ejs-daterangepicker id='range'> 
 *   <e-presets>
 *    <e-preset label='Last Week' [start]=new Date('06/07/2018') [end]= new Date('06/01/2018')></e-preset>
 *    <e-preset label='Last Month' [start]=new Date('06/07/2018') [end]= new Date('05/07/2018')></e-preset>
 *   </e-presets>
 * </ejs-daterangepicker>
 * ```
 */
export class PresetDirective extends ComplexBase<PresetDirective> {
public directivePropList: any;
/**
 * Defines the end date of the preset range
 */
public end: any;
/**
 * Defines the label string of the preset range.
 */
public label: any;
/**
 * Defines the start date of the preset range.
 */
public start: any;
/**
 * @param {?} viewContainerRef
 */
constructor(private viewContainerRef:ViewContainerRef) {
        super();
        setValue('currentInstance', this, this.viewContainerRef);
        this.registerEvents(outputs);
        this.directivePropList = input;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'e-presets>e-preset',
    inputs: input,
    outputs: outputs,    
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function PresetDirective_tsickle_Closure_declarations() {
/** @type {?} */
PresetDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PresetDirective.ctorParameters;
/** @type {?} */
PresetDirective.prototype.directivePropList;
/**
 * Defines the end date of the preset range
 * @type {?}
 */
PresetDirective.prototype.end;
/**
 * Defines the label string of the preset range.
 * @type {?}
 */
PresetDirective.prototype.label;
/**
 * Defines the start date of the preset range.
 * @type {?}
 */
PresetDirective.prototype.start;
/** @type {?} */
PresetDirective.prototype.viewContainerRef;
}

/**
 * Preset Array Directive
 */
export class PresetsDirective extends ArrayBase<PresetsDirective> {
constructor() {
        super('presets');
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'ejs-daterangepicker>e-presets',
    queries: {
        children: new ContentChildren(PresetDirective)
    },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PresetsDirective_tsickle_Closure_declarations() {
/** @type {?} */
PresetsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PresetsDirective.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
